import { bool, number, shape, string } from 'prop-types';

const appearance = shape({
  abandonEmailConfirmed: bool.required,
  abandonEmailSent: bool.required,
  acceptedAbandonBasketTerms: bool.required,
  acceptedTermsAndConditions: bool.required,
  addressFormat: shape({
    fields_groups: shape({
      field_groups: shape({
        fields: shape([]),
      }).isRequired, 
      wrapper: shape({
        className: string.isRequired,
      }),
    }).isRequired,
    required_fields: shape([]).isRequired,
    required_fields_credit_agencies: shape([]).isRequired,
    title_options: shape({
      label: string.isRequired,
      value: string.isRequired,
    }).isRequired,
  }).isRequired,
  bookingOverviewExpanded: bool.required,
  dibsFormArgs: shape([]),
  guestsWidgetVisible: bool.required,
  imageUrl: string.isRequired,
  isNarrow: bool.required,
  loading: bool.required,
  needsUpdateFromBackend: bool.required,
  needsValidateVoucher: bool.required,
  originalAgencyNumber: bool.required,
  originalCreditAgency: bool.required,
  pagerIndex: number.isRequired,
  selectedFinalCleaning: bool,
  showAbandonBasketPopup: bool.required,
  submitLoading: bool.required,
  termsAndConditionsLink: string.required,
  totalSteps: number.isRequired,
  voucherEnabledForMarketBrand: bool.required,
});

export { appearance as default };
